import { FC } from 'react';
import { JobList } from '../JobList';
import { NearArea } from '../NearArea';
import styles from '../../screens/index.module.scss';
import { PageProps } from '../../index.page';

/**
 * MainContentsのProps
 * @param nearAreaData 近隣エリアデータ
 * @param similarKeywordList 類似キーワードリスト
 */
interface Props {
  nearAreaData: PageProps['nearAreaData'];
  similarKeywordList: PageProps['similarKeywordList'];
}

export const MainContents: FC<Props> = ({
  nearAreaData,
  similarKeywordList,
}) => {
  return (
    <>
      <JobList similarKeywordList={similarKeywordList} />
      {nearAreaData && (
        <div className={styles.jobSearchList__nearbyArea}>
          <NearArea nearAreaData={nearAreaData} />
        </div>
      )}
    </>
  );
};
